(function (upp) {
    'use strict';

    upp.controller('upp.points.PointsRedeemCtrl', ['pointsService', 'appi', '$scope','$routeParams','$window', '$rootScope',
        function (pointsService, appi, $scope, $routeParams, $window, $rootScope) {
            appi.security.securable({scope:$scope})
                .then(function () {
                    appi.ui.changeActualOption({moduleKey2Display: 'point-redeem', navbarKey: 'point-redeem'}, "/pointscard");
                    appi.ui.showPageLoadingMsg();

                    var prizeId = appi.utils.getIdFromParams($routeParams.id);
                    $scope.sections = {
                        qr: 'qr',
                        gift: 'gift'
                    };

                    /**
                     * Show Main Div
                     *
                     */
                    $scope.showMainWindow = function () {
                        $window.location.href = "#!/pointscard"
                    };

                    /**
                     * Getting Points Programs
                     */
                    pointsService.getPrizePointCard(prizeId)
                        .then(function (prize) {
                            $scope.prize = prize;
                            $scope.section = $scope.sections.qr;

                            var checker = pointsService.checkRedeemPoints();
                            checker.onRedeemPrize(function() {
                                $scope.current -= $scope.prize.points;
                                $scope.section = $scope.sections.gift;
                            });

                            var watcher = $rootScope.$on('$routeChangeStart', function($event, next, current) {
                                if (checker && checker.cancel) {
                                    checker.cancel();
                                }
                                watcher();
                            });

                            appi.ui.hidePageLoadingMsg();
                        });

                    pointsService.getUserPoints().then(function(userPoints) {
                        $scope.current = userPoints.current;
                    });

                })
        }
    ]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/points/controllers/points-redeem-controller.js